// src/components/checkout/PaymentMethod.js
import React from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Alert,
  Paper,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl
} from '@mui/material';
import vodafoneCashLogo from '../../assets/images/Vodafone-Cash.png';

const PaymentMethod = ({
  paymentMethod,
  handlePaymentMethodChange,
  paymentScreenshot,
  setPaymentScreenshot,
  finalTotal,
  error,
  setError,
  onNext,
  onBack
}) => {
  const handleNextClick = () => {
    if (paymentMethod === 'vodafone_cash' && !paymentScreenshot) {
      setError('الرجاء رفع صورة إيصال الدفع');
      return;
    }
    setError('');
    onNext();
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom  sx={{ fontWeight: 'bold' }}>
        اختر طريقة الدفع
      </Typography>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          aria-label="payment-method"
          name="payment-method"
          value={paymentMethod}
          onChange={handlePaymentMethodChange}
        >
          <Paper 
            variant="outlined" 
            sx={{ 
              mb: 2, 
              p: 2, 
              borderColor: paymentMethod === 'vodafone_cash' ? 'primary.main' : 'grey.300',
              borderWidth: paymentMethod === 'vodafone_cash' ? 2 : 1
            }}
          >
            <FormControlLabel 
              value="vodafone_cash" 
              control={<Radio disabled />} 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={vodafoneCashLogo}
                    alt="Vodafone Cash"
                    style={{ height: '30px', marginRight: '10px' }}
                  />
                  <Typography  sx={{ fontWeight: 'bold' }}>فودافون كاش</Typography>
                </Box>
              } 
            />
            {paymentMethod === 'vodafone_cash' && (
              <Box sx={{ mt: 2, pl: 4 }}>
                <Alert severity="info" sx={{ mb: 2 }}>
                  الرجاء تحويل المبلغ {finalTotal.toFixed(2)} جنيه إلى رقم فودافون كاش{' '}
                  <b>01000000000</b> ثم رفع صورة الإيصال أدناه
                </Alert>
                <TextField
                  fullWidth
                  type="file"
                  inputProps={{ accept: 'image/*' }}
                  onChange={(e) => setPaymentScreenshot(e.target.files[0])}
                  required
                  helperText="الرجاء رفع صورة إيصال الدفع"
                />
              </Box>
            )}
          </Paper>
          <Paper 
            variant="outlined" 
            sx={{ 
              p: 2, 
              borderColor: paymentMethod === 'cash_on_delivery' ? 'primary.main' : 'grey.300',
              borderWidth: paymentMethod === 'cash_on_delivery' ? 2 : 1
            }}
          >
            <FormControlLabel 
              value="cash_on_delivery" 
              control={<Radio />} 
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography  sx={{ fontWeight: 'bold' }}>الدفع عند الاستلام</Typography>
                </Box>
              } 
            />
            {paymentMethod === 'cash_on_delivery' && (
              <Box sx={{ mt: 1, pl: 4 }}>
                <Alert severity="info">
                  سيتم دفع المبلغ {finalTotal.toFixed(2)} جنيه عند استلام الطلب
                </Alert>
              </Box>
            )}
          </Paper>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Button onClick={onBack} sx={{ mt: 1, mr: 1, fontWeight: 'bold' }}>
          رجوع
        </Button>
        <Button
          variant="contained"
          onClick={handleNextClick}
          sx={{ mt: 1, ml: 1, fontWeight: 'bold' }}
        >
          التالي
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentMethod;